<template>
  <div>
    <Head title="Rutas | Sub-rutas | Día" />
    <h1 class="text-3xl font-bold mb-5">
      <Link class="text-sky-400 hover:text-sky-600" :href="`/routes/${route.id}/sub-routes`">Sub-rutas</Link>
      <span class="text-sky-400 font-medium">/</span>
      {{ route.description }}
    </h1>
    <div class="bg-white rounded-md shadow max-w-2xl">
    </div>
  </div>
  <form @submit.prevent="store">
    <div class="container">
      <div class="sub_container">
        <h1 class="text-3xl text-center font-bold mb-5">Clientes de Ruta</h1>
        <draggable v-model="clients_route" transition="100" class="drop-zone">
          <template v-slot:item="{ item }">
            <div class="draggable-item">
              {{ item.name_client }} 
            </div>
          </template>
        </draggable>
      </div>
      <div class="sub_container">
        <h1 class="text-3xl text-center font-bold mb-5">Clientes de {{ day.name }}</h1>
        <draggable :key="draggableKey" v-model="clients_begin_day" transition="100" class="drop-zone">
          <template v-slot:item="{ item }">
            <div class="draggable-item">
              {{ item.name_client }} 
            </div>
          </template>
        </draggable>
      </div>      
    </div>
    <div class="flex items-center justify-center px-8 py-4  border-t border-gray-100">
      <loading-button :loading="form.processing" class="btn-sky" type="submit">Actualizar Lista de
        Clientes</loading-button>
    </div>
  </form>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import mapValues from 'lodash/mapValues';
import Search from '@/Shared/Search';
import DialogInput from '@/Shared/Dialog';
import TextInput from '@/Shared/TextInput';
import LoadingButton from '@/Shared/LoadingButton';
import Icon from '@/Shared/Icon';
import InputFile from '@/Shared/InputFile';
import TextareaInput from '@/Shared/TextareaInput';
import SelectInput from '@/Shared/SelectInput';
import Draggable from "vue3-draggable";

export default {
  components: {
    Head,
    Link,
    Search,
    DialogInput,
    LoadingButton,
    TextInput,
    Icon,
    SelectInput,
    TextareaInput,
    InputFile,
    Draggable
  },
  layout: Layout,
  props: {
    non_existing_clients: Array,
    existing_clients: Array,
    route: Object,
    day: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        clients_to_day: '',
        clients_delete_day: '',
        route: this.route.id,
        day: this.day.id
      }),
      dialogValue: '',
      draggableKey: 0, // clave inicial
      clients_begin_day_original: this.existing_clients.map(obj => ({
        id_day_route_client: obj.id_day_route_client,
        id_client: obj.id,
        name_client: obj.description,
        operation: 0, // 1-> Add, 2-> Update, 3-> Delete
      })),
      clients_begin_day: this.existing_clients.map(obj => ({
        id_day_route_client: obj.id_day_route_client,
        id_client: obj.id,
        name_client: obj.description,
        operation: 0, // 1-> Add, 2-> Update, 3-> Delete
      })),
      clients_route: this.non_existing_clients.map(obj => ({
        id_day_route_client: 0,
        id_client: obj.id,
        name_client: obj.description,
        operation: 0, // 1-> Add, 2-> Update, 3-> Delete
      })),
    };
  },
  watch: {
    'non_existing_clients': function (newVal, oldVal) {
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },
    getDeletes(arr1, arr2) {
      return arr1.filter(obj1 => !arr2.some(obj2 => obj1.id_client === obj2.id_client));
    },
    store() {
      (async () => {
        try {
          const clients_delete = this.getDeletes(this.clients_begin_day_original, this.clients_begin_day);
          this.clients_to_day = this.clients_begin_day;
          const arrayWithIndex = this.clients_to_day.map((obj, order) => {
            return { ...obj, order };
          });
          this.form.clients_to_day = arrayWithIndex;
          this.form.clients_delete_day = clients_delete;
          await this.$inertia.post(`/routes/sub-routes/update`, this.form);
        } catch (error) {
          console.error('Error al enviar datos:', error);
        }
      })();
    },
  },
};
</script>

<style>
.container {
  width: 100%;
  display: flex;
  height: auto;
}

.sub_container {
  background-color: #ffffff;
  width: 50%;
  height: 420px;
  margin: 1%;
  padding: 1%;
}

.draggable-item {
  display: flex;
  color: #ffffff;
  font: 1em sans-serif;
  justify-content: center;
  background-color: rgb(4, 122, 162);
  box-shadow: 0px 2px 5px #aaa;
  margin: 1%;
  padding: 4%;
}

.drop-zone {
  background-color: #ffffff;
  width: 100%;
  height: 340px;
  overflow-y: scroll;
}
</style>
